import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import {MatTableDataSource, MatPaginator, MatSort,} from '@angular/material';
import * as $ from 'jquery';

var COMP = environment.component.policy;
export interface Element {
  column1: string;
  column2: string;
  column3: string;
  column4: string;
  column5: string;
  column6: string;
  column7: string;
  column8: string;
}

const ELEMENT_DATA: Element[] =[
  {
     column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
     column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
     column3: "GLAAS Country Dataset",
     column4: "http://www.who.int/water_sanitation_health/glaas/en/",
     column5: "A1",
     column6: "No",
     column7: "National Laws",
     column8: "Does the constitution or other legislation recognize water and sanitation as human rights?"
  },
  {
     column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
     column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
     column3: "GLAAS Country Dataset",
     column4: "http://www.who.int/water_sanitation_health/glaas/en/",
     column5: "A10",
     column6: "No",
     column7: "Community and User Participation",
     column8: "Are there clearly defined procedures in laws or policies for participation by service users (e.g. households) and communities in planning programmes and what is the level of participation? [choices supplied]"
  },
  {
     column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
     column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
     column3: "GLAAS Country Dataset",
     column4: "http://www.who.int/water_sanitation_health/glaas/en/",
     column5: "A11",
     column6: "No",
     column7: "Public reporting/ Complaints",
     column8: "Do members of the public have an effective mechanism to file complaints concerning the lack of or unsatisfactory sanitation and drinking-water services?  [choices supplied]"
  },
  {
     column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
     column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
     column3: "GLAAS Country Dataset",
     column4: "http://www.who.int/water_sanitation_health/glaas/en/",
     column5: "A2",
     column6: "Yes",
     column7: "National Policy and Plans",
     column8: "Do national policies and implementation plans exist, and to what is the level of implementation? [choices supplied]"
  },
  {
     column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
     column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
     column3: "GLAAS Country Dataset",
     column4: "http://www.who.int/water_sanitation_health/glaas/en/",
     column5: "A3",
     column6: "No",
     column7: "National Policy and Plans",
     column8: "Please indicate the national coverage target (including the year targets are expected to be attained) as documented in the policy or plan and include a web link where available."
  },
  {
     column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
     column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
     column3: "GLAAS Country Dataset",
     column4: "http://www.who.int/water_sanitation_health/glaas/en/",
     column5: "A4",
     column6: "No",
     column7: "Service Provision by Institutional Type",
     column8: "What is the approximate population served by the following service provider types?"
  },
  {
     column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
     column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
     column3: "GLAAS Country Dataset",
     column4: "http://www.who.int/water_sanitation_health/glaas/en/",
     column5: "A5",
     column6: "No",
     column7: "Improving and Sustaining Services",
     column8: "Do plans include specific measures in any of the following areas, and how well are these measures implemented? [choices supplied]"
  },
  {
     column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
     column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
     column3: "GLAAS Country Dataset",
     column4: "http://www.who.int/water_sanitation_health/glaas/en/",
     column5: "A6",
     column6: "Yes",
     column7: "Equity Measures",
     column8: "Do policies or plans have specific measures to reach the following population groups? [choices supplied]"
  },
  {
     column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
     column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
     column3: "GLAAS Country Dataset",
     column4: "http://www.who.int/water_sanitation_health/glaas/en/",
     column5: "A7",
     column6: "No",
     column7: "Coordination",
     column8: "Please list ministries / national institutions with responsibilities in the following areas: a. governing and regulating; b. providing service (including planning, financing, and operating); c. monitoring and surveillance. Indicate the level of responsibility of the institution in each area on a scale of 1 to 4 (1. None, 2. Contributor, 3. Major contributor, 4. Lead)."
  },
  {
     column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
     column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
     column3: "GLAAS Country Dataset",
     column4: "http://www.who.int/water_sanitation_health/glaas/en/",
     column5: "A8",
     column6: "Yes",
     column7: "Coordination",
     column8: "Does a formal mechanism exist to coordinate the work of different ministries, institutions, and organizations with responsibilities for WASH (health, education, environment, agriculture, public works, etc.)? [choices supplied]"
  },
  {
     column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
     column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
     column3: "GLAAS Country Dataset",
     column4: "http://www.who.int/water_sanitation_health/glaas/en/",
     column5: "A9",
     column6: "Yes",
     column7: "Coordination",
     column8: "To what extent do development partners (donors, NGOs, international organizations, etc.) coordinate with government institutions?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "1",
     column6: "Yes",
     column7: "Institutional mapping of roles and responsibilities\nat central government level",
     column8: "At central government level, how are water policy design and implementation roles and responsibilities allocated across ministries and/or public agencies? [choices supplied]"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "3",
     column6: "Yes",
     column7: "Institutional mapping of roles and responsibilities\nat central government level",
     column8: "How are central government roles and responsibilities in water policy-making defined?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "4",
     column6: "No",
     column7: "Institutional mapping of roles and responsibilities\nat central government level",
     column8: "Beyond the ministries and agencies previously mentioned, are there other actors responsible for the design, implementation and regulation of water policies at central government level?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "6",
     column6: "Yes",
     column7: "Institutional mapping of roles and responsibilities\nat central government level",
     column8: "How are the actions of these different ministries and agencies coordinated at central government level?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "2A",
     column6: "No",
     column7: "Institutional mapping of roles and responsibilities\nat central government level",
     column8: "In your country, are there legislations on compulsory service delivery commitment, and water quality and quantity standards?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "2B",
     column6: "No",
     column7: "Institutional mapping of roles and responsibilities\nat central government level",
     column8: "At central government level, how are regulatory powers allocated across ministries and/or public agencies? [choices supplied]"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "2C",
     column6: "No",
     column7: "Institutional mapping of roles and responsibilities\nat central government level",
     column8: "Has your country set up specific regulatory agency(ies) in the water sector?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "6A",
     column6: "No",
     column7: "Institutional mapping of roles and responsibilities\nat central government level",
     column8: "Please select two main or innovative mechanisms above-mentioned and provide for more in depth information"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "6C",
     column6: "No",
     column7: "Institutional mapping of roles and responsibilities\nat central government level",
     column8: "Are there efforts to specifically coordinate water and energy policies at central government level?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "6D",
     column6: "No",
     column7: "Institutional mapping of roles and responsibilities\nat central government level",
     column8: "Are there efforts to specifically coordinate water and agricultural policies at central government level?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "6E",
     column6: "No",
     column7: "Institutional mapping of roles and responsibilities\nat central government level",
     column8: "Are there efforts to coordinate water, spatial planning and broader regional policies at central government level?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "7",
     column6: "Yes",
     column7: "Institutional mapping of roles and responsibilities\nat central government level",
     column8: "At central government level, what are the most frequent obstacles to effective coordination between different administrative bodies in charge of water? [choices supplied]"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "8",
     column6: "No",
     column7: "Institutional mapping of actors/stakeholders at subnational level",
     column8: "How are water roles and responsibilities allocated at territorial level?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "8A",
     column6: "No",
     column7: "Institutional mapping of actors/stakeholders at subnational level",
     column8: "At subnational level, who is in charge of design and implementation of water policies?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "8B",
     column6: "No",
     column7: "Institutional mapping of actors/stakeholders at subnational level",
     column8: "At subnational level, who is in charge of regulation (rules production and enforcement) in the following areas"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "9",
     column6: "No",
     column7: "Institutional mapping of actors/stakeholders at subnational level",
     column8: "How are subnational governments’ water roles and responsibilities defined?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "10A",
     column6: "No",
     column7: "Institutional mapping of actors/stakeholders at subnational level",
     column8: "Regarding territorial specificities: Are there specific rules for specific territories?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "10B",
     column6: "No",
     column7: "Institutional mapping of actors/stakeholders at subnational level",
     column8: "Is the allocation of responsibilities for water-policy design, implementation and regulation at subnational level the same throughout the country?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "10C",
     column6: "No",
     column7: "Institutional mapping of actors/stakeholders at subnational level",
     column8: "Are specific territorial areas taken into account in water policy allocation of responsibilities? [choices supplied]"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "11",
     column6: "No",
     column7: "Institutional mapping of actors/stakeholders at subnational level",
     column8: "At subnational level, who is (are) responsible for implementing central government’s water policies?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "12",
     column6: "No",
     column7: "Institutional mapping of actors/stakeholders at subnational level",
     column8: "In terms of budget related to water policies (current spending and investment spending), who are the main actors?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "13",
     column6: "No",
     column7: "Institutional mapping of actors/stakeholders at subnational level",
     column8: "Beyond official allocation of water responsibilities, are some Water Users’ Associations involved in the decision-making of water policy? Please specify which one(s) and provide more information (website, contact details etc.): Are these leading groups? [choices supplied]"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "14",
     column6: "Yes",
     column7: "Institutional mapping of actors/stakeholders at subnational level",
     column8: "What are the existing mechanisms used for co-ordination between central and subnational governments in water policy-making? [choices supplied]"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "15",
     column6: "No",
     column7: "Institutional mapping of actors/stakeholders at subnational level",
     column8: "Does your country have basin agencies? What are their constituencies? What are their missions? Who is in charge of monitoring their activities?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "16",
     column6: "No",
     column7: "Institutional mapping of actors/stakeholders at subnational level",
     column8: "What are still the most frequent obstacles for effective vertical co-ordination across different levels of government?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "17",
     column6: "No",
     column7: "Building relevant knowledge and investment capacity",
     column8: "In your country, what are the co-ordination and capacity challenges at territorial level in terms of knowledge, infrastructure and investment?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "18",
     column6: "No",
     column7: "Building relevant knowledge and investment capacity",
     column8: "Which specific tools have been adopted to manage the interface between the different actors at subnational level?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "19",
     column6: "No",
     column7: "Building relevant knowledge and investment capacity",
     column8: "Which mechanisms have been adopted to build capacity at subnational level and/or adjust it to new challenges?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "20",
     column6: "No",
     column7: "Building relevant knowledge and investment capacity",
     column8: "Are there some water-policy experimentations at territorial level?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "21",
     column6: "No",
     column7: "Building relevant knowledge and investment capacity",
     column8: "Monitoring and enforcement of water policies at subnational level: Are there tools to measure progress in water policy implementation at a subnational level? Are monitoring systems standardised across basins? Is this information used for benchmarking subnational bodies in charge of water? Is this information made public? (e.g. to water users and NGOs)"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "22",
     column6: "Yes",
     column7: "Opinions about governance challenges in water-policy making",
     column8: "In your country, what are the main governance challenges in water policy-making?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "23",
     column6: "No",
     column7: "Opinions about governance challenges in water-policy making",
     column8: "Water governance and Transboundary issues: Is your country or region sharing water resources (basin, lakes, rivers etc.) or areas (sea etc.) with neighbouring countries? Which ministry(ies)/public agency(ies) is(are) in charge of transboundary water issues? What are the main governance challenges linked to transboundary water issues? Have specific mechanisms been adopted to adjust these challenges? How do these mechanisms perform? (10-15 lines)"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "24",
     column6: "No",
     column7: "Opinions about governance challenges in water-policy making",
     column8: "Water governance and risk management: Does your country face governance challenges linked to risk management (floods, droughts, fires etc.)? Have arrangements, regulations or reforms been experimented to tackle these challenges?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "25",
     column6: "No",
     column7: "Opinions about governance challenges in water-policy making",
     column8: "Water governance and Climate change: Has climate change entailed an evolution of water governance in your country (e.g. new stakeholders, establishment of performance indicators, new allocation of responsibilities etc.)? Have arrangements, regulations or reforms been experimented to tackle these challenges?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "26",
     column6: "No",
     column7: "Opinions about governance challenges in water-policy making",
     column8: "Generally speaking, has your country recently experienced innovative practices in water governance in any of the following areas or intends to do so in the near future? New design of water policies; New design of legislative and regulatory framework? Co-ordination reforms? Innovative delivery of water services (desalinisation, social engineering, recycling used water etc.)? Other (specify):"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "27",
     column6: "No",
     column7: "Opinions about governance challenges in water-policy making",
     column8: "Which subnational case study or specific mechanism adopted by your country could be relevant for a more in depth analysis?"
  },
  {
     column1: "OECD Survey on Water Governance",
     column2: "http://www.oecd.org/governance/regional-policy/44689618.pdf",
     column3: "None found",
     column4: "",
     column5: "28",
     column6: "No",
     column7: "Opinions about governance challenges in water-policy making",
     column8: "Which example from another country would you be interested in to be developed?"
  },
  {
     column1: "UNU-INWEH",
     column2: "None",
     column3: "None found",
     column4: "",
     column5: "",
     column6: "Yes",
     column7: "SDG relevant institutions",
     column8: "What proportion of institutions are considering structural or other changes in order to better achieve this target?"
  },
  {
     column1: "UNU-INWEH",
     column2: "None",
     column3: "None found",
     column4: "",
     column5: "",
     column6: "Yes",
     column7: "SDG relevant institutions",
     column8: "How is public awareness rated, on a national level for this target?"
  },
  {
     column1: "UNU-INWEH",
     column2: "None",
     column3: "None found",
     column4: "",
     column5: "",
     column6: "Yes",
     column7: "SDG relevant institutions",
     column8: "Has the lead Government  Ministry/Institution developed  mechanisms for cooperation with  private institutions or business entrepreneurs that could contribute to the achievement of this targets?"
  },
  {
     column1: "UNU-INWEH",
     column2: "None",
     column3: "None found",
     column4: "",
     column5: "",
     column6: "Yes",
     column7: "SDG relevant institutions",
     column8: "How many planning events - for example, meetings, workshops, conferences, and/or stakeholder consultations - have been organised by the government for awareness and planning?"
  },
  {
     column1: "UNU-INWEH",
     column2: "None",
     column3: "None found",
     column4: "",
     column5: "",
     column6: "Yes",
     column7: "SDG relevant institutions",
     column8: "How is public awareness rated, on a national level for this target?"
  }
 ]

@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.css']
})
export class PolicyComponent implements OnInit {


//@ViewChild(MatPaginator) paginator: MatPaginator;
@ViewChild(MatSort) sort: MatSort;

  displayedColumns = ['column1', 'column2', 'column3', 'column4', 'column5', 'column6', 'column7', 'column8'];
  dataSource: MatTableDataSource<Element>;

  constructor(private router: Router) {
    this.dataSource = new MatTableDataSource(ELEMENT_DATA);
   }

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".policy-click").addClass("header_active")
  }
  ngAfterViewInit() {
    //this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  addQuestion(){
      this.router.navigateByUrl('/sdg/add-question/'+COMP)
  }
  quesBtnClick(){
    this.router.navigateByUrl('/sdg/policy-quest')
  }
  dataBtnClick(){
    this.router.navigateByUrl('/sdg/policy-data')
  }
  reportBtnClick(){
    this.router.navigateByUrl('/sdg/policy-report')
  }
    homeBtnClick(){
        this.router.navigateByUrl('/sdg/sdg-home')
    }
}



// WEBPACK FOOTER //
// ./src/app/sdg/policy/policy.component.ts